import React from 'react';
import { motion } from 'framer-motion';
export function Lookbook() {
  return <section className="py-20 bg-acid brutal-border border-l-0 border-r-0" data-id="element-98">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <h2 className="text-6xl md:text-8xl font-black uppercase tracking-tighter mb-12 text-center" data-id="element-100">
          LOOKBOOK
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 auto-rows-[300px]" data-id="element-101">
          {/* Large Image */}
          <motion.div whileHover={{
          scale: 0.98
        }} className="md:col-span-8 row-span-2 brutal-border brutal-shadow bg-black relative overflow-hidden group" data-id="element-102">
            <img src="https://images.unsplash.com/photo-1617331721458-bd3bd3f9c7f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Look 1" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-103" />
            <div className="absolute bottom-6 right-6 bg-white text-black font-black text-2xl px-4 py-2 brutal-border" data-id="element-104">
              LOOK 01
            </div>
          </motion.div>

          {/* Small Image 1 */}
          <motion.div whileHover={{
          scale: 0.98
        }} className="md:col-span-4 row-span-1 brutal-border brutal-shadow bg-magenta relative overflow-hidden group" data-id="element-105">
            <img src="https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Look 2" className="w-full h-full object-cover mix-blend-multiply opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-106" />
          </motion.div>

          {/* Small Image 2 */}
          <motion.div whileHover={{
          scale: 0.98
        }} className="md:col-span-4 row-span-1 brutal-border brutal-shadow bg-electric relative overflow-hidden group" data-id="element-107">
            <img src="https://images.unsplash.com/photo-1529139574466-a303027c1d8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Look 3" className="w-full h-full object-cover mix-blend-luminosity opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" data-id="element-108" />
          </motion.div>
        </div>
      </div>
    </section>;
}